export const fiscalData = {
	title: "DATOS FISCALES",
	fields: {
		ncm: {
			label: "NCM",
			placeholder: "Introducir NCM",
			tooltip: "Nomenclatura Común del Mercosur",
		},
		cest: {
			label: "CEST",
			placeholder: "Introducir CEST",
			tooltip: "Código Especificador de Sustitución Tributaria",
		},
		fiscalProfile: {
			label: "Perfil fiscal",
			placeholder: "Seleccionar perfil fiscal",
			loading: "Cargando...",
			tooltip:
				"Conjunto de datos que describe la situación fiscal de una persona o empresa.",
		},
		fiscalGroup: {
			label: "Grupo fiscal",
			placeholder: "Seleccionar grupo fiscal",
			loading: "Cargando...",
			tooltip: "Grupo fiscal es un código que clasifica productos según su tributación.",
		},
		hasIcmsRetido: {
			label: "¿Tiene ICMS pagado anteriormente por Sustitución Tributaria (ST)?",
			options: {
				yes: "Sí, tiene ICMS pagado anteriormente por ST",
				no: "No, no tiene ICMS pagado anteriormente por ST",
			},
		},
		fiscalIcmsBaseCalculoRetSt: {
			label: "Base de cálculo del ICMS Retenido en la operación anterior",
			placeholder: "valor en R$",
		},
		fiscalIcmsValorSubstituto: {
			label: "Valor del ICMS propio del sustituto",
			placeholder: "valor en R$",
		},
		fiscalIcmsAliquotaFinal: {
			label: "Alícuota soportada por el consumidor final",
			placeholder: "valor en porcentaje %",
		},
	},
};
